import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { t } from '@/utils/translator';
import i18n from '@/i18n';
import { Layout, Typography, Form, Input, Select, Button, message, Modal } from 'antd';
import { Row, Col } from 'antd';
import QESG_AssessmentLogo from '@images/QESG_Assessment_basic.svg?react';
import LanguageSwitcher from '@common/LanguageSwitcher';
import API from '@/api/api';

const { Header: AntHeader, Footer: AntFooter } = Layout;
const { Title } = Typography;

function Register() {
  const navigate = useNavigate();
  const { search } = useLocation();

  const resStepLabels = ['기업 정보', '담당자 정보', '신청완료'];
  const [isStepLoading, setStepLoading] = useState(false);
  const [regStep, setRegStep] = useState(0);
  const [isComfirmedUser, setComfirmedUser] = useState(false);
  const [companyForm] = Form.useForm();
  const [userForm] = Form.useForm();
  const [isAbleToNext, setAbleToNext] = useState(false);
  const [isAlreadyRegistered, setAlreadyRegistered] = useState(false);
  const [isShowRegisterGuidModal, showRegisterGuidModal] = useState(false);
  const [registerData, setRegisterData] = useState({
    vendor_code: null,
    vendor_code_used: null,
    user_email: null,
    user_username: null,
    user_phone_nationcode: null,
    user_phonenumber: null,
    user_password: null,
  });

  const [companyFormInitData, setCompanyFormInitData] = useState({
    company_project_code: null,
    company_name: null,
    company_code: null,
    company_vender_code: null,
  });

  const [userFormInitData, setUserFormInitData] = useState({
    user_email: null,
    user_username: null,
    user_phone_nationcode: null,
    user_phonenumber: null,
    user_password: null,
    user_password_confirm: null,
  });

  const RegFormNationCode = [
    { text: '미국 (+1)', text_en: 'United States (+1)', value: '+1' },
    { text: '캐나다 (+1)', text_en: 'Canada (+1)', value: '(+1)' },
    {
      text: '남아프리카공화국 (+27)',
      text_en: 'Republic of South Africa (+27)',
      value: '(+27)',
    },
    { text: '프랑스 (+33)', text_en: 'France (+33)', value: '(+33)' },
    { text: '스페인 (+34)', text_en: 'Spain (+34)', value: '(+34)' },
    { text: '헝가리 (+36)', text_en: 'Hungary (+36)', value: '(+36)' },
    { text: '이탈리아 (+39)', text_en: 'Italy (+39)', value: '(+39)' },
    { text: '루마니아 (+40)', text_en: 'Romania (+40)', value: '(+40)' },
    { text: '스위스 (+41)', text_en: 'Switzerland (+41)', value: '(+41)' },
    { text: '오스트리아 (+43)', text_en: 'Austria (+43)', value: '(+43)' },
    { text: '영국 (+44)', text_en: 'United Kingdom (+44)', value: '(+44)' },
    { text: '스웨던 (+46)', text_en: 'Sweden (+46)', value: '(+46)' },
    { text: '폴란드 (+48)', text_en: 'Poland (+48)', value: '(+48)' },
    { text: '독일 (+49)', text_en: 'Germany (+49)', value: '(+49)' },
    { text: '멕시코 (+52)', text_en: 'Mexico (+52)', value: '(+52)' },
    { text: '브라질 (+55)', text_en: 'Brazil (+55)', value: '(+55)' },
    { text: '인도네시아 (+62)', text_en: 'Indonesia (+62)', value: '(+62)' },
    { text: '일본 (+81)', text_en: 'Japan (+81)', value: '(+81)' },
    { text: '한국 (+82)', text_en: 'Korea (+82)', value: '(+82)' },
    { text: '베트남 (+84)', text_en: 'Vietnam (+84)', value: '(+84)' },
    { text: '중국 (+86)', text_en: 'China (+86)', value: '(+86)' },
    { text: '터키 (+90)', text_en: 'Turkey (+90)', value: '(+90)' },
    { text: '인도 (+91)', text_en: 'India (+91)', value: '(+91)' },
    { text: '룩셈브루크 (+352)', text_en: 'Luxembourg (+352)', value: '(+352)' },
    { text: '세르비아 (+381)', text_en: 'Serbia (+381)', value: '(+381)' },
    { text: '몬테네그로 (+382)', text_en: 'Montenegro (+382)', value: '(+382)' },
    { text: '체코 (+420)', text_en: 'Czech (+420)', value: '(+420)' },
    { text: '슬로바키아 (+421)', text_en: 'Slovakia (+421)', value: '(+421)' },
  ];

  const confirmCompanyInfo = () => {
    setRegStep(1);
    setAbleToNext(false);
  };

  useEffect(() => {
    const ValidateVendorCode = async () => {
      try {
        setStepLoading(true);
        const query = new URLSearchParams(search);
        const [pc, vc] = [query.get('pc'), query.get('vc')];

        if (!pc || !vc) {
          showRegisterGuidModal(true);
          // return alert("프로젝트 참여 신청시 참여신청 전용 URL을 통해 접속해주세요.")
          return false;
        }

        if (pc && vc) {
          const _res_check_vc = await API.get('/register/vendor_codes', { params: { pc, vc } });
          const VC = _res_check_vc.data;

          setCompanyFormInitData({
            company_project_code: VC.project.project_code,
            company_name: VC.company.company_name,
            company_code: VC.company.company_code,
            company_vender_code: VC.vendor_code,
          });

          companyForm.setFieldsValue({
            company_project_code: VC.project.project_code,
            company_name: VC.company.company_name,
            company_code: VC.company.company_code,
            company_vender_code: VC.vendor_code,
          });

          setAbleToNext(true);
          setRegisterData((prev) => ({
            ...prev,
            project_code: VC.project.project_code,
            vendor_code: VC.vendor_code,
            vendor_code_used: VC.used,
          }));
        }
      } catch (error) {
        let _AlertMessage =
          '프로젝트 참여를 위한 벤더코드 조회중 장애가 발생했습니다. QESG 기후팀(carbon@qesg.co.kr) 로 문의해주시기 바랍니다.';
        if (error?.response) {
          const errorDetail = error.response?.data?.detail;
          if (errorDetail === 'INVALID_REGISTER_REQUEST') {
            _AlertMessage =
              '잘못된 참여신청 입니다. 참여신청 및 가입 URL로 재접속해주시기 바랍니다.';
          } else if (errorDetail === 'NOT_FOUND_VENDORCODE') {
            _AlertMessage = '유효하지 않은 벤더코드 입니다. 확인 후 다시 신청해주시기 바랍니다.';
          }
        }

        message.error(t(_AlertMessage));
        console.log(error);
        setAbleToNext(false);
      } finally {
        setStepLoading(false);
      }
    };

    ValidateVendorCode();
  }, []);

  const confirmUserInfo = async () => {
    try {
      setStepLoading(true);
      if (!isComfirmedUser) {
        let ResValidatedUser = await API.get('/register/user', {
          params: { email: userForm.getFieldValue('user_email') },
        });

        ResValidatedUser = ResValidatedUser.data;
        if (!ResValidatedUser) {
          setComfirmedUser(true);
          setAbleToNext(false);
        } else if (isComfirmedUser && registerData.vendor_code_used && ResValidatedUser) {
          setAlreadyRegistered(true);
          setRegStep(2);
        } else {
          await API.post('/register/request', {
            ...registerData,
            user_username: ResValidatedUser.username,
            user_email: ResValidatedUser.email,
            lang: i18n.language,
          });
          setRegStep(2);
        }
      } else {
        let userData = userForm.getFieldsValue();
        const {
          user_email,
          user_password,
          user_phone_nationcode,
          user_phonenumber,
          user_position,
          user_username,
        } = userData;

        await API.post('/register/request', {
          ...registerData,
          user_email,
          user_password,
          user_username,
          user_phonenumber: user_phone_nationcode + ' ' + user_phonenumber,
          user_position,
          lang: i18n.language,
        });
        setRegStep(2);
      }
    } catch (error) {
      let _AlertMessage =
        '프로젝트 참여를 위한 벤더코드 조회중 장애가 발생했습니다. QESG 기후팀(carbon@qesg.co.kr) 로 문의해주시기 바랍니다.';

      // API 응답이 있는 경우
      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 && data?.detail) {
          const errorDetail = data.detail;

          // 비밀번호 관련 에러 처리
          const passwordErrors = {
            INVALID_PASSWORD: '유효하지 않은 비밀번호입니다.',
            PASSWORD_NOT_CHANGED: '현재 비밀번호와 동일한 비밀번호를 입력해주세요.',
            PASSWORD_MINIMUM_LENGTH_8_REQUIRED: '비밀번호는 최소 8자리 이상이어야 합니다.',
            PASSWORD_AT_LEAST_2_CHARACTER_TYPES_REQUIRED:
              '숫자, 영문, 특수문자 중 최소 2개이상을 조합해 주세요.',
            PASSWORD_2_CHARACTER_TYPES_REQUIRE_MINIMUM_LENGTH_10:
              '숫자, 영문, 특수문자 중 최소 2가지 이상 그리고 10자리 이상의 비밀번호여야 합니다.',
            PASSWORD_REQUIRE_2_TYPES_MIN_10_OR_3_TYPES_MIN_8:
              '숫자, 영문, 특수문자 중 최소 2가지 이상에 10자리 또는 숫자, 영문, 특수문자 중 모두 사용한 최소 8자리의 비밀번호를 사용해주세요.',
            INVALID_EMPTY_PASSWORD: '유효하지 않은 비밀번호입니다',
            INVALID_SAMEID_PASSWORD: '계정 ID와 동일한 비밀번호는 사용하실 수 없으십니다.',
            INVALID_SEQUENTIAL_PASSWORD: '연속된 문자 및 숫자는 사용하실 수 없으십니다.',
            INVALID_REPEATWORD_PASSWORD: '반복된 문자 및 숫자는 사용하실 수 없으십니다.',
            PAST_USED_PASSWORD: '과거에 사용한 비밀번호 입니다.',
          };

          if (passwordErrors[errorDetail]) {
            _AlertMessage = passwordErrors[errorDetail];
          } else {
            _AlertMessage = '입력 정보를 확인해주세요.';
          }
        } else if (status === 409) {
          _AlertMessage = '이미 등록된 정보입니다. 다른 정보로 시도해주세요.';
        } else if (status === 404) {
          _AlertMessage = '요청한 정보를 찾을 수 없습니다.';
        } else if (status === 500) {
          _AlertMessage = '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
        } else {
          _AlertMessage = '요청 처리 중 오류가 발생했습니다.';
        }
      } else {
        _AlertMessage =
          '참여신청 및 가입 도중 오류가 발생했습니다. QESG 기후팀(carbon@qesg.co.kr)에 문의해주시기 바랍니다.';
      }

      message.error(t(_AlertMessage));
    } finally {
      setStepLoading(false);
    }
  };

  // 기업 정보 및 담당자 정보 입력에 따른 "다음" 버튼 활성화
  const handleFormValueChange = (_, allValues) => {
    let requiredFields = [];
    if (regStep === 0) {
      requiredFields = Object.keys(companyFormInitData);
    } else if (regStep === 1 && !isComfirmedUser) {
      requiredFields = ['user_email'];
    } else if (regStep === 1 && isComfirmedUser) {
      requiredFields = Object.keys(userFormInitData);
    }

    const isFilled = requiredFields.every((key) => {
      if (key === 'user_email') {
        return !!allValues[key] && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(allValues[key]);
      } else {
        return !!allValues[key];
      }
    });

    // 비밀번호 확인 로직 추가
    let isPasswordValid = true;
    if (
      regStep === 1 &&
      isComfirmedUser &&
      allValues.user_password &&
      allValues.user_password_confirm
    ) {
      isPasswordValid = allValues.user_password === allValues.user_password_confirm;
    }

    setAbleToNext(isFilled && isPasswordValid);
  };

  return (
    <Layout
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <AntHeader
        className="d-flex justify-content-between align-items-center"
        style={{ backgroundColor: 'transparent' }}
      >
        <Link to="/" className="d-inline-block lh-0" style={{ maxWidth: '120px', width: '100%' }}>
          <QESG_AssessmentLogo className="h-100 w-100" />
        </Link>

        <LanguageSwitcher />
      </AntHeader>

      <Modal
        title={t('참여신청 안내')}
        open={isShowRegisterGuidModal}
        okText={t('나가기')}
        onOk={() => navigate('/')}
        cancelButtonProps={{ style: { display: 'none' } }}
        maskClosable={false}
        centered
      >
        <div className="text-center">
          <p className="mb-2" style={{ fontSize: '15px' }}>
            {t('프로젝트 참여 신청시 참여신청 전용 URL을 통해 접속해주세요.')}
          </p>
          <p className="mb-0" style={{ fontSize: '15px' }}>
            {t('프로젝트 참여 관련 문의사항은 carbon@qesg.co.kr 로 문의해주세요.')}
          </p>
        </div>
      </Modal>

      <div className="p-4">
        <Row justify="center" align="middle" className="mb-3" style={{ width: '100%' }}>
          <Col xs={24} md={12} lg={10}>
            <div className="text-center">
              <Title level={2}>{t('가입 및 신청')}</Title>
            </div>

            <div className="">
              <Row justify="space-between" align="bottom">
                {resStepLabels.map((stepLabel, stepLabelIdx) => (
                  <Col xs={12} lg={7} key={`reg-step-${stepLabelIdx}`}>
                    <div
                      className={clsx(
                        'border-bottom border-dark pb-1',
                        regStep === stepLabelIdx && 'border-2',
                        regStep !== stepLabelIdx && 'border-1'
                      )}
                    >
                      <div className={clsx(regStep === stepLabelIdx && 'fw-bold')}>
                        Step {stepLabelIdx + 1}.
                      </div>
                      <div className={clsx(regStep === stepLabelIdx && 'fw-bold fs-5')}>
                        {t(stepLabel)}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
        {regStep === 0 && (
          <Row justify="center" align="middle" style={{ width: '100%' }}>
            <Col xs={24} md={12} lg={10}>
              <div className="bg-white rounded-2 shadow-sm p-4">
                <Form
                  form={companyForm}
                  labelCol={{ span: 14 }}
                  layout="vertical"
                  labelAlign="left"
                  labelWrap
                  initialValues={companyFormInitData}
                  onValuesChange={handleFormValueChange}
                >
                  <Form.Item
                    label={t('프로젝트 코드')}
                    name="company_project_code"
                    rules={[{ required: true }]}
                    className="mb-3"
                  >
                    <Input
                      placeholder={t('프로젝트 코드를 입력해주세요')}
                      disabled
                      className="text-dark"
                    />
                  </Form.Item>
                  <Form.Item
                    label={t('기업명')}
                    name="company_name"
                    rules={[{ required: true }]}
                    className="mb-3"
                  >
                    <Input
                      placeholder={t('기업명을 입력해주세요')}
                      disabled
                      className="text-dark"
                    />
                  </Form.Item>
                  <Form.Item
                    label={t('벤더코드')}
                    name="company_vender_code"
                    rules={[{ required: true }]}
                    className="mb-4"
                  >
                    <Input
                      placeholder={t('벤더코드를 입력해주세요')}
                      disabled
                      className="text-dark"
                    />
                  </Form.Item>

                  <Form.Item className="text-end mb-0">
                    <Button
                      type="primary"
                      onClick={() => confirmCompanyInfo()}
                      disabled={!isAbleToNext}
                      loading={isStepLoading}
                    >
                      {t('다음')}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        )}
        {regStep === 1 && (
          <Row justify="center" align="middle" style={{ width: '100%' }}>
            <Col xs={24} md={12} lg={10}>
              <div className="bg-white rounded-2 shadow-sm p-4">
                <Form
                  form={userForm}
                  labelCol={{ span: 14 }}
                  layout="vertical"
                  labelAlign="left"
                  labelWrap
                  initialValues={userFormInitData}
                  onValuesChange={handleFormValueChange}
                >
                  <Row>
                    <Col xs={24}>
                      <Form.Item
                        label={t('계정 ID (E-mail)')}
                        name="user_email"
                        rules={[{ required: true, message: '이메일을 입력해주세요' }]}
                        className={clsx(!isComfirmedUser && 'py-4', 'mb-3')}
                      >
                        <Input
                          type="email"
                          placeholder={t('계정 ID (E-mail)를 입력해주세요')}
                          disabled={isStepLoading}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  {isComfirmedUser && (
                    <Row gutter={[12, 12]}>
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label={t('성함')}
                          name="user_username"
                          rules={[{ required: true }]}
                          className="mb-1"
                        >
                          <Input placeholder={t('성함을 기재해주세요')} disabled={isStepLoading} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={12}>
                        <Form.Item
                          label={t('직책')}
                          name="user_position"
                          rules={[{ required: true }]}
                          className="mb-1"
                        >
                          <Input placeholder={t('직책을 기재해주세요')} disabled={isStepLoading} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={8}>
                        <Form.Item
                          label={t('국가 코드')}
                          name="user_phone_nationcode"
                          rules={[{ required: true }]}
                          className="mb-1"
                        >
                          <Select
                            fieldNames={{
                              label: i18n.language === 'ko' ? 'text' : 'text_en',
                              value: 'value',
                            }}
                            options={RegFormNationCode}
                            placeholder={t('국가 코드를 선택해주세요')}
                            disabled={isStepLoading}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} lg={16}>
                        <Form.Item
                          label={t('전화번호')}
                          name="user_phonenumber"
                          rules={[{ required: true }]}
                          className="mb-1"
                        >
                          <Input
                            placeholder={t('전화번호을 기재해주세요')}
                            disabled={isStepLoading}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24}>
                        <Form.Item
                          label={t('비밀번호')}
                          name="user_password"
                          rules={[{ required: true }]}
                          className="mb-1"
                        >
                          <Input
                            type="password"
                            placeholder={t('비밀번호을 기재해주세요')}
                            disabled={isStepLoading}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24}>
                        <Form.Item
                          label={t('비밀번호 확인')}
                          name="user_password_confirm"
                          rules={[{ required: true }]}
                          className="mb-4"
                        >
                          <Input
                            type="password"
                            placeholder={t('비밀번호 확인을 위해 비밀번호를 입력해주세요')}
                            disabled={isStepLoading}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}

                  <Form.Item className="text-end mb-0">
                    <Button
                      type="primary"
                      onClick={() => confirmUserInfo()}
                      disabled={!isAbleToNext || isStepLoading}
                      loading={isStepLoading}
                    >
                      다음
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        )}
        {regStep === 2 && (
          <Row justify="center" align="middle" style={{ width: '100%' }}>
            <Col xs={24} md={12} lg={10}>
              <div className="bg-white rounded-2 shadow-sm p-4">
                <div className="p-4">
                  {!isAlreadyRegistered && (
                    <Title level={3}>{t('회원가입 및 참여신청이 완료되었습니다.')}</Title>
                  )}

                  {isAlreadyRegistered && (
                    <Title level={3}>{t('이미 회원가입 및 참여신청이 완료하셨습니다.')}</Title>
                  )}

                  <div className="fs-6 mb-5">{t('로그인 후 이용하여 주십시오.')}</div>
                  <div className="text-end">
                    <Button type="primary" onClick={() => navigate('/')}>
                      로그인
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
      <AntFooter className="py-2" style={{ background: '#f5f5f5' }}>
        <Row>
          <Col xs={24} md={12}>
            <div className="d-flex align-items-center text-start">
              <div className="d-lg-inline-block fw-medium me-3 mb-0" style={{ fontSize: '15px' }}>
                {t('(주)퀀티파이드이에스지')}
              </div>
              <div className="d-lg-inline-block lh-1" style={{ fontSize: '13px' }}>
                copyright 2025 QuantifiedESG, Inc. | All Rights Reserved
              </div>
            </div>
          </Col>
          <Col xs={24} md={12}>
            <div
              className="d-flex align-items-center justify-content-end"
              style={{ fontSize: '13px' }}
            >
              <div className="lh-2"> {t('개인정보 처리방침')}</div>
              <div className="mx-2">|</div>
              <div className="lh-1">{t('이용약관')}</div>
              <div className="mx-2">|</div>
              <div className="lh-1">{t('시스템 문의')}</div>
            </div>
          </Col>
        </Row>
      </AntFooter>
    </Layout>
  );
}

export default Register;
